import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=2e099c38&scoped=true&"
import script from "./EditTask.vue?vue&type=script&lang=js&"
export * from "./EditTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e099c38",
  null
  
)

export default component.exports